// extracted by mini-css-extract-plugin
export default {"gallery_box":"gallery_gallery_box__5jn-E"};